import type { Hit } from 'algoliasearch'
import type { Hit as BaseHit } from 'instantsearch.js'
import groupBy from 'lodash-es/groupBy'

export function groupByDay(items: Hit<BaseHit>[]) {
  const sortedByTimestamp = items.sort((a, b) => a.date - b.date)

  const grouping = groupBy(sortedByTimestamp, (item) => {
    const d = new Date(item.date)
    d.setHours(0, 0, 0, 0)
    return d.getTime()
  })

  return Object.entries(grouping).map(([key, value]) => ({
    date: Number(key),
    items: value
  }))
}
